export type ProductivityMetric = 'sv' | 'spi' | 'cv' | 'cpi' | 'etc' | 'eac'

export type ProductivityInput = {
  total: number | null
  scheduledCompleted: number | null
  completed: number | null
  actualResource: number | null
}

export const calcRemaining = (
  total: number | null,
  completed: number | null
): number | null => {
  if (total == null || completed == null) return null
  return total - completed
}

const calcRate = (
  value: number | null,
  total: number | null
): number | null => {
  if (!total || value == null) return null
  return value / total
}

export const calcScheduledProgressRate = (
  scheduledCompleted: number | null,
  total: number | null
): number | null => calcRate(scheduledCompleted, total)

export const calcProgressRate = (
  completed: number | null,
  total: number | null
): number | null => calcRate(completed, total)

export const calcProductivity = (
  metric: ProductivityMetric,
  input: ProductivityInput
): number | null => {
  const { total, scheduledCompleted, completed, actualResource } = input
  if (
    total == null ||
    scheduledCompleted == null ||
    completed == null ||
    actualResource == null
  ) {
    return null
  }
  if (total === 0) return null

  const ev = completed
  const pv = scheduledCompleted
  const ac = actualResource
  const bac = total
  const cpi = ac === 0 ? null : ev / ac

  switch (metric) {
    case 'sv':
      return ev - pv
    case 'spi':
      return pv === 0 ? null : ev / pv
    case 'cv':
      return ev - ac
    case 'cpi':
      return cpi
    case 'etc':
      return cpi ? (bac - ev) / cpi : null
    case 'eac':
      return cpi ? bac / cpi : null
    default:
      return null
  }
}

export const calcExpectedProfitRatio = (
  forecastRevenue: number | null,
  actualUsedBudget: number | null,
  remainingBudget: number | null
): number | null => {
  if (
    forecastRevenue == null ||
    actualUsedBudget == null ||
    remainingBudget == null
  ) {
    return null
  }
  const totalCost = actualUsedBudget + remainingBudget
  if (totalCost === 0) return null
  return forecastRevenue / totalCost
}
